import { ConvertedThresholds, Threshold } from '../models/Thresholds';

export function convertThresholds(thresholds: Threshold[]) {
  const converted: ConvertedThresholds = {};

  thresholds.forEach(threshold => {
    const metric = threshold.metric!;
    if (!converted[metric]) {
      converted[metric] = {
        high: Number.MAX_SAFE_INTEGER,
        low: Number.MIN_SAFE_INTEGER,
      };
    }
    const type = threshold.predicate === '>' ? 'high' : 'low';
    converted[metric]![type] = threshold.value!;
  });

  return converted;
}
